import { render, staticRenderFns } from "./GymViewMode.vue?vue&type=template&id=4a8222b5&scoped=true&"
import script from "./GymViewMode.vue?vue&type=script&lang=js&"
export * from "./GymViewMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8222b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8222b5')) {
      api.createRecord('4a8222b5', component.options)
    } else {
      api.reload('4a8222b5', component.options)
    }
    module.hot.accept("./GymViewMode.vue?vue&type=template&id=4a8222b5&scoped=true&", function () {
      api.rerender('4a8222b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Gym/Includes/GymViewMode.vue"
export default component.exports